/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Password_HintInputs */

const es_cap_password_hint = /** @type {(inputs: Cap_Password_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mínimo 10 caracteres.`)
};

const gl_cap_password_hint = /** @type {(inputs: Cap_Password_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mínimo 10 caracteres.`)
};

const en_cap_password_hint = /** @type {(inputs: Cap_Password_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At least 10 characters.`)
};

/**
* | output |
* | --- |
* | "At least 10 characters." |
*
* @param {Cap_Password_HintInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_password_hint = /** @type {((inputs?: Cap_Password_HintInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Password_HintInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_password_hint(inputs)
	if (locale === "en") return en_cap_password_hint(inputs)
	return es_cap_password_hint(inputs)
});